import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
